module.exports = __webpack_public_path__ + "static/media/Screenshot_2.258fb7b5.png";